import { Typography } from '@material-tailwind/react';
import { useEffect, useState } from 'react';
import {
  copulaParticle,
  formatDDay,
  formatKstDateWithWeekday,
  formatRemainingTime,
  removeSurname,
} from '../../api/utils/util-func';
import { FreeTrialContextItem } from '../../constants/types/free-trial/type';

interface FreeTrialPromotionBarProps {
  freeTrialContext: FreeTrialContextItem;
}

/* 상단 프로모션 바 */
const FreeTrialPromotionBar = ({
  freeTrialContext,
}: FreeTrialPromotionBarProps) => {
  const [freeTrialTime, setFreeTrialTime] = useState({
    dDay: '-',
    remainingTime: '-',
  });

  useEffect(() => {
    const expireAt = freeTrialContext?.expireAt;

    if (!expireAt) {
      setFreeTrialTime({
        dDay: '-',
        remainingTime: '-',
      });
      return;
    }

    const updateTrialTime = () => {
      setFreeTrialTime({
        dDay: formatDDay(expireAt),
        remainingTime: formatRemainingTime(expireAt),
      });
    };

    // 최초 즉시 계산
    updateTrialTime();

    // 이후 1초마다 갱신
    const interval = window.setInterval(updateTrialTime, 1000);

    return () => {
      window.clearInterval(interval);
    };
  }, [freeTrialContext?.expireAt]);

  return (
    <div className="bg-[#35208C] text-white">
      <div className="mx-auto max-w-[1180px] px-4 py-3.5 md:flex md:items-center md:justify-between md:gap-3 md:px-6 md:py-3">
        {/* 모바일 */}
        <div className="md:hidden">
          <div className="flex items-start justify-between gap-3">
            <div className="flex min-w-0 items-center gap-2.5">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-full bg-[#FFF6CC]">
                <img
                  src="/images/free-trial/bready.png"
                  alt="bready"
                  className="h-full w-full object-contain"
                />
              </div>

              <div className="min-w-0">
                <Typography className="truncate text-[10px] font-medium text-white/70">
                  잉스바 Book 1 · In the beginning
                </Typography>

                <Typography className="text-[20px] font-extrabold leading-tight">
                  <span className="text-[#FFD928]">
                    {copulaParticle(removeSurname(freeTrialContext.childName))}
                  </span>
                  <span className="text-white">의 무료체험</span>
                </Typography>
              </div>
            </div>
          </div>

          <div className="mt-3 flex items-center gap-3 rounded-xl bg-white/10 px-3 py-2.5">
            <Typography className="text-[20px] font-black leading-none text-[#FFD928]">
              {freeTrialTime.dDay}
            </Typography>

            <div>
              <Typography className="text-[11px] font-bold text-white">
                {freeTrialTime.remainingTime} 남았어요
              </Typography>

              <Typography className="text-[10px] font-medium text-white/65">
                {freeTrialTime.dDay}
                {formatKstDateWithWeekday(freeTrialContext.expireAt, {
                  showTime: true,
                })}
                까지 이용할 수 있어요
              </Typography>
            </div>
          </div>
        </div>

        {/* PC - 기존 디자인 유지 */}
        <div className="hidden md:flex md:min-w-0 md:items-center md:gap-3">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center overflow-hidden rounded-full bg-[#FFF6CC]">
            <img
              src="/images/free-trial/bready.png"
              alt="bready"
              className="h-full w-full object-contain"
            />
          </div>

          <div className="min-w-0">
            <Typography className="text-[11px] font-semibold text-white">
              잉스바 Book 1 · In the beginning
            </Typography>

            <Typography className="text-[30px] font-extrabold leading-tight">
              <span className="text-[#FFD928]">
                {copulaParticle(removeSurname(freeTrialContext.childName))}
              </span>
              <span className="text-white">의 무료체험</span>
            </Typography>
          </div>
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <Typography className="text-[30px] font-black text-[#FFD928]">
            {freeTrialTime.dDay}
          </Typography>

          <div>
            <Typography className="text-[12px] font-extrabold text-white">
              {freeTrialTime.remainingTime} 남았어요
            </Typography>

            <Typography className="text-[11px] text-white">
              {formatKstDateWithWeekday(freeTrialContext.expireAt, {
                showTime: true,
              })}
              까지 이용할 수 있어요
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FreeTrialPromotionBar;
